export default {
    data() {
        return {
            status: 1,
            keyword: '',
            openDateFrom: '',
            openDateTo: ''
        };
    }
}